"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = require("satcheljs");
/* tslint:enable:forbid-import */
var showFullOptions_1 = require("./showFullOptions");
var confirmDirtyOptionsAndPerformAction_1 = require("./confirmDirtyOptionsAndPerformAction");
exports.default = satcheljs_1.orchestratorAction('navigateToSearchSuggestion', function navigateToSearchSuggestion(category, subcategory, option) {
    var continueAfterConfirmCallback = function () {
        showFullOptions_1.default(category, subcategory, option);
    };
    confirmDirtyOptionsAndPerformAction_1.default(continueAfterConfirmCallback);
});
//# sourceMappingURL=navigateToSearchSuggestion.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/orchestration/owa-options-orchestration/lib/orchestrators/navigateToSearchSuggestion.js
// module id = 5281
// module chunks = 2